var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.139 29.2954C34.1668 27.2121 30.6947 25.9621 25.8335 24.1564C24.8613 23.8787 24.3043 23.7397 24.028 22.9051C23.7502 22.2106 23.7502 21.3787 24.3043 20.6842C26.2502 18.6009 27.2223 15.5454 27.2223 11.5176C27.2223 6.37874 23.6098 4.01758 20.0002 4.01758C16.389 4.01758 12.7765 6.37874 12.7765 11.6564C12.7765 15.6842 13.7502 18.7397 15.5543 20.8217C15.9723 21.5162 16.1113 22.3509 15.8335 23.0454C15.5543 23.7397 15.0002 23.8787 14.028 24.2939C9.16683 26.1009 5.69466 27.3509 4.72233 29.4342C3.889 31.2384 3.3335 33.1842 3.3335 35.2676C3.3335 35.6842 3.61133 35.9621 4.028 35.9621H35.9723C36.3877 35.9621 36.6668 35.6842 36.6668 35.2676C36.6668 33.1842 36.1098 31.2384 35.139 29.2954Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.1950999205abc2989b45f76477a12caf.svg";
export { ForwardRef as ReactComponent };